import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { statisticAction } from '@store/statistic'
import { policyAction } from '@store/policy'
import { strategyAction } from '@store/strategy'
import { alarmAction } from '@store/alarm'
import { monitorAction } from '@store/monitor'
import { connect } from 'react-redux'
import moment from 'moment'
import { Form, Input, Icon, Button, Table, message, Popconfirm } from 'antd'

const { create } = Form
let id = 0

const superParams = {}
@create()
@connect(
  state => {
    return {}
  },
  dispatch => bindActionCreators(
    Object.assign({}, statisticAction, policyAction, strategyAction, alarmAction, monitorAction )
  , dispatch)
)
class NoteForm extends PureComponent {
  static propTypes = {}

  static defaultProps = {}

  state = {
    isLoading: false
  }

  initProps = {
    idName: 'ID', // 展示的字段名
    variable: {}, // 请求需要的参数
    dataRequest: '', // 请求列表数据时的接口名
    deleteRequest: '', // 删除时的接口名
    list: [], // 表格列表中的数据
    total: 0 // 列表的页数
  }

  formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 }
  }

  formItemLayoutWithOutLabel = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19, offset: 5 }
  }

  queryParams = {
    pageNo: 1,
    pageSize: 5,
    ...superParams
  }

  tableColumns = [
    {
      title: '备注信息',
      dataIndex: 'remark',
      key: 'remark',
      width: 200,
      align: "center",
      render: remark => <span>{remark}</span>
    },
    {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 180,
        align: "center",
        render: createTime => createTime ? <span>{moment(createTime).format('YYYY-MM-DD HH:mm:ss')}</span> : ''
      },
      {
        title: '创建人',
        dataIndex: 'createUser',
        key: 'createUser',
        width: 100,
        align: "center",
        render: createUser => createUser ? <span>{createUser}</span> : ''
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 100,
        align: "center",
        render: (value, row) => this.renderAction(value, row)
      },
  ]

  componentWillMount() {
    this.loadResource()
  }

  componentWillUnmount() {
    this.queryParams.pageNo = 1
  }

  renderAction = (value, row) => {
    const { deleted, remarkId } = row
    const action = deleted ?
    (
      <Fragment>
        <Popconfirm
          title={
            <p>
              请问确认要删除吗？
            </p>
          }
          onConfirm={() => {
            this.handleDelete(remarkId)
          }}
          okText="确认"
          cancelText="不了"
        >
          <Button type="link" size="small">
            删除
          </Button>
        </Popconfirm>
      </Fragment>
    ) :
    ''
    return action
  }

  loadResource = async () => {
    try {
      const { queryParams } = this
      const { variable, dataRequest } = this.props
      const param = {
        ...queryParams,
        ...variable
      }
      this.setState({ isLoading: true })
      await this.props[dataRequest](param)
    } finally {
      this.setState({ isLoading: false})
    }
  }

  pageChange = page => {
    this.queryParams.pageNo = page
    this.loadResource()
  }

  handleDelete = async remarkId => {
    try {
      const { variable, deleteRequest } = this.props
      const params = {
        ...variable,
        remarkId
      }
      this.setState({ isLoading: true })
      this.queryParams.pageNo = 1
      await this.props[deleteRequest](params)
      message.success('删除成功')
      this.loadResource()
    } finally {
      this.setState({ isLoading: false })
    }
  }

  handleAdd = () => {
    const { form } = this.props
    const keys = form.getFieldValue('keys')
    id += 1
    const nextKeys = keys.concat(id)
    form.setFieldsValue({
      keys: nextKeys
    })
  }

  handleRemove = k => {
    const { form } = this.props
    const keys = form.getFieldValue('keys')
    if (keys.length === 1) {
      return
    }
    form.setFieldsValue({
      keys: keys.filter(key => key !== k)
    })
  }

  renderAddRemark = () => {
    const { formItemLayout, formItemLayoutWithOutLabel, props } = this
    const { getFieldDecorator, getFieldValue } = props.form
    getFieldDecorator('keys', { initialValue: [id] })
    const keys = getFieldValue('keys')
    return (
      <Fragment>
        {keys.map((k, index) => (
          <Form.Item
            {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
            label={index === 0 ? '新增备注' : ''}
            required={index === 0}
            key={k}
          >
            {getFieldDecorator(`contents[${k}]`, {
              rules: [
                {
                  required: true,
                  message: `请输入备注信息`,
                  whitespace: true
                },
                { max: 200, message: '支持最大输入字符200' }
              ]
              })(<Input placeholder="请输入备注信息" style={{ marginRight: 8, width: '90%' }} />)
            }
            {keys.length > 1 ?
            (
              <Icon
                className="dynamic-delete-button"
                type="minus-circle-o"
                onClick={() => this.handleRemove(k)}
              />
            ) :
            null
            }
          </Form.Item>
        ))}
        <Form.Item {...formItemLayoutWithOutLabel}>
          <Button
            disabled={keys.length >= 10}
            type="dashed"
            onClick={this.handleAdd}
            style={{ width: '90%' }}
          >
            <Icon type="plus" />
          </Button>
        </Form.Item>
      </Fragment>
    )
  }

  render() {
    const { props, state, formItemLayout, renderAddRemark, tableColumns, queryParams } = this
    const { variable, idName, list, total} = props
    const { isLoading } = state
    const { pageNo, pageSize } = queryParams
    const pagination = {
      current: pageNo,
      pageSize,
      total,
      showTotal: total => `共${total}条`,
      onChange: this.pageChange
    }
    return (
      <Fragment>
        <Form {...formItemLayout}>
          <Form.Item label={idName}>
            <span className="ant-form-text">{Object.values(variable)[0]}</span>
          </Form.Item>
          {renderAddRemark()}
          <Table
            size="small"
            bordered
            dataSource={list}
            columns={tableColumns}
            loading={isLoading}
            rowKey={record => {[record.remarkId, record.createTime].join('_')}}
            pagination={pagination}
          />
        </Form>
      </Fragment>
    )
  }
}

export default NoteForm